// =============================================================================
// PageSection — Content section wrapper
// =============================================================================

import clsx from "clsx";

interface PageSectionProps {
  children: React.ReactNode;
  className?: string;
}

export function PageSection({ children, className }: PageSectionProps) {
  return <section className={clsx("page-section mx-auto w-full max-w-[1600px]", className)}>{children}</section>;
}

export function StickyHeader({ children, className }: PageSectionProps) {
  return <div className={clsx("sticky-header", className)}>{children}</div>;
}
